import React from 'react';
export function AnnouncementBar() {
  return;
}